import axios from "axios";

// En production, le frontend et l’API sont servis sur le même domaine : /api.
// En développement local, React (3001) parle automatiquement au backend (8000).
const isLocalhost = typeof window !== "undefined" &&
  ["localhost", "127.0.0.1"].includes(window.location.hostname);

const configuredBackend = process.env.REACT_APP_BACKEND_URL?.trim();
const BACKEND_URL = configuredBackend || (isLocalhost ? "http://localhost:8000" : "");
export const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Token fallback (in case cookie blocked by browser)
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

export default api;
